import {
  EfsMelcoEfsModelsEfsDefaultFormat,
  EfsMelcoEfsModelsEfsUserResponseSetting,
  ProductionFulfillmentApi,
  useProductionFulfillmentApi,
} from "melco-shared-logic";
import { useCallback } from "react";

const initialValue = { settings: undefined };

export type TransformedBasicSettings =
  EfsMelcoEfsModelsEfsUserResponseSetting & {
    embroidery_output_format?: Array<EfsMelcoEfsModelsEfsDefaultFormat> | null;
    print_output_format?: Array<EfsMelcoEfsModelsEfsDefaultFormat> | null;
  };

type BasicSettings = {
  settings?: TransformedBasicSettings;
};

const transformSettings = (
  settings: EfsMelcoEfsModelsEfsUserResponseSetting
): TransformedBasicSettings => {
  const { output_format } = settings;

  const print_output_format = output_format?.filter(
    (option) => option.extension && option.service_type === "PRINT"
  );

  const embroidery_output_format = output_format?.filter(
    (option) => option.extension && option.service_type === "EMBROIDERY"
  );

  return { ...settings, print_output_format, embroidery_output_format };
};

export const useBasicSettings = () => {
  const handleRequest = useCallback(async (api: ProductionFulfillmentApi) => {
    const settings = await api.accountProductSettingsGetEfsUserSetting();

    return { settings: transformSettings(settings) };
  }, []);

  return useProductionFulfillmentApi<BasicSettings>({
    initialValue,
    handleRequest,
  });
};
